import { bool } from 'prop-types';
import React, { useRef } from 'react';

import HoverDetails from '../../generic/HoverDetails';
import IconLink from '../../generic/IconLink';
import { zmsAMMerchantShape } from '../../prop-types';
import { withFullName } from '../../users/utils';
import { getYesNoValue } from '../../utils/create-csv';

function MerchantLink({ model, showIcon, ...rest }) {
  const linkRef = useRef(null);
  const {
    id,
    name,
    merchantId,
    pc,
    salesUnit,
    salesTeam,
    isSelfService,
    framework,
    hasTransitionDiscount,
    countries,
  } = model;
  const salesUnits = pc
    ? { 'Managed Service Sales Unit': pc.salesUnit }
    : { 'Self Service Sales Unit': salesUnit };
  return (
    <>
      <span ref={linkRef}>
        <IconLink showIcon={showIcon} to={`/merchants/${id}/show`} {...rest}>
          {name}
        </IconLink>
      </span>
      <HoverDetails
        size="large"
        linkRef={linkRef}
        title={name}
        fields={{
          'Merchant Id': merchantId,
          PC: withFullName(pc).fullName || '-',
          ...salesUnits,
          'Sales Team': salesTeam,
          Framework: framework,
          'Self Service': getYesNoValue(isSelfService),
          'Transition Discount': getYesNoValue(hasTransitionDiscount),
          Markets: (countries || []).map(country => country).join(', '),
        }}
      />
    </>
  );
}

MerchantLink.propTypes = {
  model: zmsAMMerchantShape.isRequired,
  showIcon: bool,
};

MerchantLink.defaultProps = {
  showIcon: false,
};

export default MerchantLink;
